import { apiFetch } from "./client";

/** One currency of the list: dinars per `unit` of the currency (1 or 100), zero where the bank's list leaves it out. */
export type ExchangeRate = {
  code: string;
  unit: number;
  middle: number;
  buying: number;
  selling: number;
  cashBuying: number;
  cashSelling: number;
};

/** The list the ERP holds; `day` differs from `askedFor` when the asked day has none and an earlier one is shown. */
export type ExchangeRateList = {
  askedFor: string;
  day: string | null;
  listNumber: number | null;
  documentNumber: string | null;
  rates: ExchangeRate[];
};

export const exchangeRatesApi = {
  get: (day?: string) =>
    apiFetch<ExchangeRateList>(`/admin/exchange-rates${day ? `?day=${encodeURIComponent(day)}` : ""}`),
};
